export default __webpack_public_path__ + "static/media/ID_LABORATORY_Ms JONES.39770f6a.jpg";